// Servizio API per comunicare con il backend
const API_BASE_URL = process.env.REACT_APP_API_URL;

class ApiService {
  // Metodo helper per fare richieste HTTP
  async request(endpoint, options = {}) {
    const url = `${API_BASE_URL}${endpoint}`;
    
    // Ottieni il token di autenticazione dal localStorage
    const token = localStorage.getItem('adminToken');
    
    const config = {
      headers: {
        'Content-Type': 'application/json',
        ...(token && { 'Authorization': `Bearer ${token}` }),
        ...options.headers,
      },
      ...options,
    };

    try {
      const response = await fetch(url, config);
      
      if (!response.ok) {
        const errorData = await response.json().catch(() => ({}));
        throw new Error(errorData.error || `HTTP error! status: ${response.status}`);
      }
      
      return await response.json();
    } catch (error) {
      console.error(`API Error (${endpoint}):`, error);
      throw error;
    }
  }

  // GET request
  async get(endpoint) {
    return this.request(endpoint, { method: 'GET' });
  }

  // POST request
  async post(endpoint, data) {
    return this.request(endpoint, {
      method: 'POST',
      body: JSON.stringify(data),
    });
  }

  // MOVIES - Gestione completa film con MongoDB
  async getMovies() {
    return this.get('/movies');
  }

  async getMovie(id) {
    return this.get(`/movies/${id}`);
  }

  async createMovie(movieData) {
    return this.post('/movies', movieData);
  }

  async updateMovie(id, movieData) {
    return this.request(`/movies/${id}`, {
      method: 'PUT',
      body: JSON.stringify(movieData),
    });
  }

  async deleteMovie(id) {
    return this.request(`/movies/${id}`, {
      method: 'DELETE',
    });
  }

  // TMDB Integration
  async searchTMDB(query) {
    return this.get(`/tmdb/search?query=${encodeURIComponent(query)}`);
  }

  async getTMDBMovie(tmdbId) {
    return this.get(`/tmdb/movie/${tmdbId}`);
  }

  async updateMovieFromTMDB(movieId, tmdbId) {
    return this.post(`/movies/${movieId}/update-from-tmdb`, { tmdbId });
  }

  // PROGRAMMAZIONE
  async getProgrammazione() {
    return this.get('/programmazione');
  }

  async updateProgrammazione(data) {
    return this.post('/programmazione', data);
  }

  async updateSingleMovieSchedule(movieId) {
    return this.post('/programmazione/update-single', { movieId });
  }

  // SHOWTIMES - Gestione orari spettacoli
  async getShowtimes(movieId) {
    return this.get(`/movies/${movieId}/showtimes`);
  }

  async addShowtime(movieId, showtimeData) {
    return this.post(`/movies/${movieId}/showtimes`, showtimeData);
  }

  async updateShowtime(movieId, showtimeId, showtimeData) {
    return this.request(`/movies/${movieId}/showtimes/${showtimeId}`, {
      method: 'PUT',
      body: JSON.stringify(showtimeData),
    });
  }

  async deleteShowtime(movieId, showtimeId) {
    return this.request(`/movies/${movieId}/showtimes/${showtimeId}`, {
      method: 'DELETE',
    });
  }

  // LIVETICKET
  async getLiveticket() {
    return this.get('/liveticket');
  }

  // SLIDER
  async getSlider() {
    return this.get('/slider');
  }

  async createSlide(slideData) {
    return this.post('/slider', slideData);
  }

  async updateSlide(id, slideData) {
    return this.request(`/slider/${id}`, {
      method: 'PUT',
      body: JSON.stringify(slideData),
    });
  }

  async deleteSlide(id) {
    return this.request(`/slider/${id}`, {
      method: 'DELETE',
    });
  }

  async updateSliderBulk(data) {
    return this.post('/slider/bulk', data);
  }

  // RASSEGNE
  async getRassegne() {
    return this.get('/rassegne');
  }

  async createRassegna(rassegnaData) {
    return this.post('/rassegne', rassegnaData);
  }

  async updateRassegna(id, rassegnaData) {
    return this.request(`/rassegne/${id}`, {
      method: 'PUT',
      body: JSON.stringify(rassegnaData),
    });
  }

  async deleteRassegna(id) {
    return this.request(`/rassegne/${id}`, {
      method: 'DELETE',
    });
  }

  async updateRassegneBulk(data) {
    return this.post('/rassegne/bulk', data);
  }

  // OSPITI
  async getOspiti() {
    return this.get('/ospiti');
  }

  async updateOspiti(data) {
    return this.post('/ospiti', data);
  }

  // AGGIORNAMENTO AUTOMATICO DA LIVETICKET
  async updateFromLiveticket() {
    return this.post('/update-from-liveticket', {});
  }

  // HEALTH CHECK
  async healthCheck() {
    return this.get('/health');
  }
}

// Esporta un'istanza singleton
const apiService = new ApiService();
export default apiService;

// Esporta anche la classe per eventuali test
export { ApiService };